import React, { useEffect, useState } from "react";
import Web3 from "web3";
import { useAppKitAccount } from "@reown/appkit/react";
import { useConnectorClient } from "wagmi";

import { ReserveContract } from "../config/contractConfig";
import ReserveContarctABI from "../abis/ReserveContarctABI.json";
import Loader from "../components/Loader";
import Nodata from "../assets/img/no-record-found.png";

import {
  FaWallet,
  FaHashtag,
  FaMoneyBillWave,
  FaBoxOpen,
  FaClock,
  FaCopy,
  FaCheck,
  FaFilter,
} from "react-icons/fa";

const formatBalance = (balance) =>
  balance ? parseFloat(balance).toFixed(6) : "0.000000";

const LeaderBonus = () => {
  const { address, isConnected } = useAppKitAccount();
  const { data: client } = useConnectorClient();

  const [web3, setWeb3] = useState(null);
  const [bonusList, setBonusList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 12;
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [loading, setLoading] = useState(true);

  // 🔍 FILTER STATES (UI SAME)
  const [searchValue, setSearchValue] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [levelFilter, setLevelFilter] = useState("");
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);

  // INIT WEB3
  useEffect(() => {
    let provider = null;
    if (client?.transport) provider = client.transport;
    else if (window.ethereum) provider = window.ethereum;
    if (!provider) return;
    setWeb3(new Web3(provider));
  }, [client]);

  // FETCH ON CONNECT
  useEffect(() => {
    if (isConnected && address && web3) {
      fetchLevelBonus();
    }
  }, [address, isConnected, web3]);

  // =========================
  // FETCH DATA
  // =========================
  const fetchLevelBonus = async () => {
    setLoading(true);
    try {
      const contract = new web3.eth.Contract(
        ReserveContarctABI,
        ReserveContract
      );

      const res = await contract.methods.reward_details(address).call();

      const {
        _reward_timestamp = [],
        _reward_credited = [],
        _reward_type = [],
        _reward_level = [],
        _reward_from = [],
        _reward_flag = [],
      } = res;

      const list = [];

      for (let i = 0; i < _reward_type.length; i++) {
        if (Number(_reward_type[i]) === 6) {
          const rawDate = new Date(
            Number(_reward_timestamp[i]) * 1000
          );

          list.push({
            from: _reward_from[i],
            amount: Web3.utils.fromWei(
              _reward_credited[i].toString(),
              "ether"
            ),
            level: Number(_reward_level[i]),
            flag: Number(_reward_flag[i]),
            status:
              Number(_reward_flag[i]) === 1 ? "Success" : "Flushed",
            timestamp: rawDate.toLocaleString(),
            dateRaw: rawDate, // ⭐ REQUIRED FOR DATE FILTER
          });
        }
      }

      setBonusList(list.reverse());
    } catch (e) {
      console.error("Error fetching reward details:", e);
    }
    setLoading(false);
  };

  // =========================
  // FILTER LOGIC
  // =========================
  const filteredRecords = bonusList.filter((item) => {
    const search = searchValue.toLowerCase();

    const dateValid =
      (!fromDate || item.dateRaw >= new Date(fromDate)) &&
      (!toDate || item.dateRaw <= new Date(toDate));

    const levelValid =
      levelFilter === "" || item.level === Number(levelFilter);

    const searchValid =
      item.from.toLowerCase().includes(search) ||
      item.amount.toString().includes(search) ||
      item.timestamp.toLowerCase().includes(search) ||
      item.status.toLowerCase().includes(search) ||
      String(item.level).includes(search);

    return dateValid && levelValid && searchValid;
  });

  // PAGINATION
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredRecords.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );
  const totalPages = Math.ceil(
    filteredRecords.length / recordsPerPage
  );

  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);
    setTimeout(() => setCopiedIndex(null), 1500);
  };

  const resetFilters = () => {
    setSearchValue("");
    setFromDate("");
    setToDate("");
    setLevelFilter("");
    setCurrentPage(1);
  };

  if (loading) return <Loader />;

  // =========================
  // UI (DESIGN SAME)
  // =========================
  return (
    <div className="buyshheikh-page">
      <h4 className="mb-3 mobilefiltername">
        <div>
          <span className="text-warning"> NFT </span>{" "}
          <span className="fw-lighter"> Level History</span>
        </div>
         <button
                  className="btn btn-light btn-sm"
                  onClick={() => setMobileFilterOpen(true)}
                >
                  <FaFilter /> Filter
                </button>
              </h4>
        
              <div className="card paddingfilter">
                <div className="card-body">
                  {/* MOBILE FILTER */}
                  {mobileFilterOpen && (
                    <div
                      className="overlay-bg"
                      onClick={() => setMobileFilterOpen(false)}
                    />
                  )}
        
                  <div
                    className={`bottom-filter-panel ${
                      mobileFilterOpen ? "show" : ""
                    }`}
                  >
                    <div
                      className="close-filter"
                      onClick={() => setMobileFilterOpen(false)}
                    >
                      ✕
                    </div>
        
                    <div className="row">
                  <div className="col-md-12 col-lg-2 mb-3">
                    <label className="form-label">From Date</label>
                    <div className="input-icon">
                    <input type="date" className="form-control"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)} />
                      <i className="fa-solid fa-calendar iconposition"></i>
                      </div>
                  </div>
        
                  <div className="col-md-12 col-lg-2 mb-3">
                    <label className="form-label">To Date</label>
                      <div className="input-icon">
                   
                    <input type="date" className="form-control"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)} /> 
                      <i className="fa-solid fa-calendar iconposition"></i>
                      </div>
                  </div>
        
                      {/* LEVEL */}
                      <div className="col-md-12 col-lg-2 mb-3">
                        <label className="form-label">Level</label>
                        <input
                          type="number"
                          className="form-control"
                          value={levelFilter}
                          onChange={(e) => setLevelFilter(e.target.value)}
                          placeholder="Level..."
                        />
                      </div>
        
                      {/* SEARCH */}
                      <div className="col-md-12 col-lg-3 mb-3">
                        <label className="form-label">Search</label>
                        <input
                          type="text"
                          className="form-control"
                          value={searchValue}
                          onChange={(e) => setSearchValue(e.target.value)}
                          placeholder="Search..."
                        />
                      </div>
        
                      {/* APPLY + RESET */}
                      <div className="col-md-12 col-lg-2 mb-3">
                        <label className="visibilty-hidden form-label">Search</label>
                      <div className="d-flex gap-2 mobleapplybtn">
                          <button
                            className="btn btn-success"
                            onClick={() => setMobileFilterOpen(false)}
                          >
                            Apply
                          </button>
                          <button className="btn btn-danger" onClick={resetFilters}>
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
        
                  {/* RECORD LIST */}
                  <div className="row">
                    {currentRecords.length > 0 ? (
                      currentRecords.map((item, index) => {
                        const maskAddress =
                          item.from.substring(0, 2) +
                          "****" +
                          item.from.substring(item.from.length - 2);

              return (
                <div className="col-md-4 mb-4" key={index}>
                  <div className="ref-card">
                    <div className="ref-card-body">
                      <div className="ref-row">
                        <span className="ref-label">
                          <FaHashtag className="ref-icon" /> S.No
                        </span>
                        <span className="ref-value">
                          {indexOfFirstRecord + index + 1}
                        </span>
                      </div>

                      <div className="ref-row">
                        <span className="ref-label">
                          <FaWallet className="ref-icon" /> From Wallet
                        </span>
                        <div className="ref-copy-box">
                          <span className="ref-value">{maskAddress}</span>
                          <button
                            className="copy-btn"
                            onClick={() => handleCopy(item.from, index)}
                          >
                            {copiedIndex === index ? (
                              <FaCheck className="copy-icon copied" />
                            ) : (
                              <FaCopy className="copy-icon" />
                            )}
                          </button>
                        </div>
                      </div>

                      <div className="ref-row">
                        <span className="ref-label">
                          <FaMoneyBillWave className="ref-icon" /> Amount (USDT)
                        </span>
                        <span className="ref-badge">
                          {formatBalance(item.amount)}
                        </span>
                      </div>

                      <div className="ref-row">
                        <span className="ref-label">
                          <FaBoxOpen className="ref-icon" /> Level
                        </span>
                        <span className="ref-value">{item.level}</span>
                      </div>

                      <div className="ref-row">
                        <span className="ref-label">
                          <FaClock className="ref-icon" /> Date & Time
                        </span>
                        <span className="ref-date">{item.timestamp}</span>
                      </div>

                      <div className="ref-row">
                        <span className="ref-label">Status</span>
                        <span
                          className={`ref-badge ${
                            item.status === "Success"
                              ? "success"
                              : "flushed"
                          }`}
                        >
                          {item.status}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="no-data">
              <img src={Nodata} alt="" />
            </div>
          )}
        </div>

        {/* PAGINATION */}
        {totalPages > 1 && (
          <div className="pagination-div">
            <ul className="pagination mb-0">
              {[...Array(totalPages)].map((_, idx) => (
                <li
                  key={idx}
                  className={`page-item ${
                    currentPage === idx + 1 ? "active" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage(idx + 1)}
                  >
                    {idx + 1}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
      </div>
  );
};

export default LeaderBonus;
